/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CartBorrowerInfosDto } from './CartBorrowerInfosDto';
import {
    CartBorrowerInfosDtoFromJSON,
    CartBorrowerInfosDtoFromJSONTyped,
    CartBorrowerInfosDtoToJSON,
    CartBorrowerInfosDtoToJSONTyped,
} from './CartBorrowerInfosDto';

/**
 * 
 * @export
 * @interface CreateBorrowerCartItemCommand
 */
export interface CreateBorrowerCartItemCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerCartItemCommand
     */
    funnelId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerCartItemCommand
     */
    borrowerProjectId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerCartItemCommand
     */
    contractIdentifier?: string;
    /**
     * 
     * @type {Array<CartBorrowerInfosDto>}
     * @memberof CreateBorrowerCartItemCommand
     */
    borrowers?: Array<CartBorrowerInfosDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerCartItemCommand
     */
    hash: string;
}

/**
 * Check if a given object implements the CreateBorrowerCartItemCommand interface.
 */
export function instanceOfCreateBorrowerCartItemCommand(value: object): value is CreateBorrowerCartItemCommand {
    if (!('funnelId' in value) || value['funnelId'] === undefined) return false;
    if (!('borrowerProjectId' in value) || value['borrowerProjectId'] === undefined) return false;
    if (!('hash' in value) || value['hash'] === undefined) return false;
    return true;
}

export function CreateBorrowerCartItemCommandFromJSON(json: any): CreateBorrowerCartItemCommand {
    return CreateBorrowerCartItemCommandFromJSONTyped(json, false);
}

export function CreateBorrowerCartItemCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBorrowerCartItemCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'funnelId': json['funnelId'],
        'borrowerProjectId': json['borrowerProjectId'],
        'contractIdentifier': json['contractIdentifier'] == null ? undefined : json['contractIdentifier'],
        'borrowers': json['borrowers'] == null ? undefined : ((json['borrowers'] as Array<any>).map(CartBorrowerInfosDtoFromJSON)),
        'hash': json['hash'],
    };
}

export function CreateBorrowerCartItemCommandToJSON(json: any): CreateBorrowerCartItemCommand {
    return CreateBorrowerCartItemCommandToJSONTyped(json, false);
}

export function CreateBorrowerCartItemCommandToJSONTyped(value?: CreateBorrowerCartItemCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'funnelId': value['funnelId'],
        'borrowerProjectId': value['borrowerProjectId'],
        'contractIdentifier': value['contractIdentifier'],
        'borrowers': value['borrowers'] == null ? undefined : ((value['borrowers'] as Array<any>).map(CartBorrowerInfosDtoToJSON)),
        'hash': value['hash'],
    };
}

